<template>
  <img
    class="lazyload block lg:hidden w-full h-full object-cover absolute left-0 top-0 z-0"
    :data-src="isJp ? 'https://cdn.shopify.com/s/files/1/0550/0524/9633/files/JP-MB.png?v=1760429565' : 'https://cdn.shopify.com/s/files/1/0550/0524/9633/files/membership-mb.png?v=1761123244'"
    alt="Image"
  />
  <template v-if="isJp">
    <img
      class="lazyload hidden lg:block w-full h-full object-cover absolute left-0 top-0 z-0"
      data-src="https://cdn.shopify.com/s/files/1/0550/0524/9633/files/JP-PC.png?v=1760429566"
      alt="Image"
    />
  </template>
  <template v-else>
    <video
        class="hidden lg:block w-full h-full object-cover absolute left-0 top-0 z-0"
        autoplay
        muted
        playsinline
      >
        <source :src="isLogin ? 'https://cdn.shopify.com/videos/c/o/v/1a31e32649f54227b8b2e7a39d43ed97.mp4' : 'https://cdn.shopify.com/videos/c/o/v/c15c661786ef46a990e68fb4491dfa70.mp4'" type="video/mp4">
      </video>
  </template>
  
</template>

<script setup>
    let {locale } = useI18n();
    const isJp = computed(() => locale.value === 'ja-JP');
    const props = defineProps({
        isLogin: Boolean
    })
</script>
